import React, { FC, ReactNode } from 'react'

import { MODAL_TALL_HEIGHT } from '../../_gluestack/modal'
import { twMerge } from '../../tailwind/merge'
import { Box } from '../box'
import { CenteredSpinner } from '../centered-spinner'
import { DialogView } from './DialogView'
import { Modal, ModalSize } from './Modal'

export interface MapAwareModalProps {
    id?: string
    size?: ModalSize
    isOpen: boolean
    content?: ReactNode
    contentHeader?: ReactNode
    contentFooter?: ReactNode
    map?: ReactNode
    mapHeader?: ReactNode
    mapFooter?: ReactNode
    view: DialogView
    isLoading?: boolean
    closeAction(): void
}

export const MapAwareModal: FC<MapAwareModalProps> = ({
    size = 'xl',
    id,
    isOpen,
    isLoading,
    closeAction,
    view,
    map,
    mapFooter,
    mapHeader,
    content,
    contentFooter,
    contentHeader,
}) => {
    const isContentView = view === DialogView.Content
    const [header, footer] = isContentView ? [contentHeader, contentFooter] : [mapHeader, mapFooter]

    if (isLoading) {
        return (
            <Modal
                nativeID={id}
                isOpen={isOpen}
                onClose={closeAction}
                title={header}
                size={size}
                className={MODAL_TALL_HEIGHT}
                bodyClassName='items-center justify-center'
            >
                <CenteredSpinner />
            </Modal>
        )
    }

    return (
        <Modal
            nativeID={id}
            isOpen={isOpen}
            onClose={closeAction}
            title={header}
            footer={footer}
            size={size}
            className={MODAL_TALL_HEIGHT}
            scrollable={false}
        >
            <Box className='relative flex-1'>
                <Box
                    className={twMerge(
                        'relative h-full flex-1 transition-transform duration-300 ease-in-out',
                        isContentView ? 'translate-x-0' : '-translate-x-full',
                    )}
                >
                    <Box className={twMerge('absolute inset-0', !isContentView && 'hidden')}>
                        {content}
                    </Box>
                    <Box className='absolute inset-0 translate-x-full'>{!isContentView && map}</Box>
                </Box>
            </Box>
        </Modal>
    )
}
